import React from 'react';
import { ButtonGrid, Container, WashButton } from './ResetWashingMachineStyles';
import axios from 'axios';

const ResetWashingMachine: React.FC = () => {
  const handleWashClick = async (machine: string) => {
    const baseUrl = 'https://api.redezandona.com.br/api/v1/car-washings/reset/';

    try {
      axios.defaults.headers.authorization = `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJtcy1wZWRpZG9zIiwic3ViIjoiY2Fpb3JlYmxpbjA3QGdtYWlsLmNvbSIsInVzZXJJZCI6IjY3ZjgwY2U4ZjZjZWY4NjYwZjhlNjhkNCIsImV4cCI6MjIwODk5OTYwMH0.GKTwEAgQ5qgPrWabR95CBU365ZopYhF5BLW53w3xXso`;
      const response = await axios.put(baseUrl + machine);
      console.log(`Requisição bem-sucedida para ${machine}:`, response.data);
    } catch (error) {
      console.error(`Erro ao enviar comando ${machine}:`, error);
    }
  };

  return (
    <Container>
      <ButtonGrid>
        <WashButton onClick={() => handleWashClick('68714a4f7e0a1d3228aa6cee')}>Maq. 1 (Z7)</WashButton>
        <WashButton onClick={() => handleWashClick('674616e0eec011255f545ff8')}>Maq. 2 (Z7)</WashButton>
        <WashButton onClick={() => handleWashClick('67461c2f8eb9591c43c2e2c4')}>Maq Z1</WashButton>
      </ButtonGrid>
    </Container>
  );
};

export default ResetWashingMachine;
